import SEO from '@/components/seo'
import type { NextPage } from 'next'
import ContactView from '@/views/contact'

const ContactPage: NextPage = () => {
  return (
    <>
      <SEO
        title="お問い合わせ"
        url="contact"
        description="ONLIVE Studio へのお問い合わせはこちらから。サービスに関するご質問・ご要望をお気軽にお送りください。"
      />
      <ContactView />
    </>
  )
}

export default ContactPage
